angular.module 'zc.commonApi'

# TODO: Deprecate and use CampaignStatsV2
.factory 'CampaignStats', ($filter, $q, Facade, FacadeV2, campaignGraphOptions, lib) ->
  BASE_ITEMS = [
    'conversion_count'
    'conversion_price'
    'delivery_count'
    'dwell'
    'cart_button_click_count'
    'history_count'
    'interest_count'
  ]
  SIGNIFICANCE_LEVEL = 0.1
  ZC_COST_RATE = 0.1

  service =
    ZC_COST_RATE: ZC_COST_RATE

    find: (params) ->
      Facade.request "/apikeys/#{params.apikey}/campaign_stats/#{params.dimension}", {
        params:
          json: params
        transformResponse: @campaignStatsResponseTransformer
      }
      .then (res) ->
        res.data?.campaign_stats

    aggregate: (params) ->
      Facade.request "/apikeys/#{params.apikey}/campaign_stats/#{params.dimension}/aggregate", {
        params:
          json: params
        transformResponse: @campaignStatsResponseTransformer
      }
      .then (res) ->
        res.data?.campaign_stats

    getCampaignStats: (params, callback) ->
      params.dimension ||= 'hourly'
      Facade.request "/apikeys/#{params.apikey}/campaigns/#{params.campaign_id}/stats/#{params.dimension}/aggregate", {
        params: params
      }
      .then (res) =>
        @groupCampaigns(res.data?.stats)

    getCampaignEventStats: (params, callback) ->
      params.dimension ||= 'hourly'
      Facade.request "/apikeys/#{params.apikey}/campaigns/#{params.campaign_id}/event_stats/#{params.dimension}/aggregate", {
        params: params
      }
      .then (res) ->
        res.data?.event_stats

    getHourlyConversionPriceDistribution: (params, callback) ->
      params.dimension ||= 'hourly'
      Facade.request "/apikeys/#{params.apikey}/campaigns/#{params.campaign_id}/conversion_price_distribution/#{params.dimension}/aggregate", {
        params: params
      }
      .then (res) ->
        res.data?.conversion_price_distribution

    getHourlyDwellDistribution: (paths, query) ->
      params = {}
      params.match = query.match
      params.pipeline = query.pipeline
      FacadeV2.request "/apikeys/#{paths.apikey}/campaign_dwell_distribution/#{paths.dimension}/aggregate", {params}
      .then (res) ->
        res.data

    getHourlyHistoryCountDistribution: (paths, query) ->
      params = {}
      params.match = query.match
      params.pipeline = query.pipeline
      FacadeV2.request "/apikeys/#{paths.apikey}/campaign_history_count_distribution/#{paths.dimension}/aggregate", {params}
      .then (res) ->
        res.data

    getInterestWidgetItemDistribution: (paths, query) ->
      params = {}
      params.match = query.match
      params.pipeline = query.pipeline
      FacadeV2.request "/apikeys/#{paths.apikey}/campaign_interest_widget_item_distribution/#{paths.dimension}/aggregate", {params}
      .then (res) ->
        res.data

    # groups aggregate result into
    # {
    #   134: {
    #     {
    #       ctrl: [obj, obj]
    #       exp: [obj, obj]
    #     }
    #   }
    # }
    groupCampaigns: (res) ->
      return {} if !res

      data = {}
      for single in res
        cid = single.campaign_id

        if !data[cid]
          data[cid] =
            ctrl: []
            exp: []

        if single.is_control
          data[cid].ctrl.push single
        else
          data[cid].exp.push single

      data

    # Stats functions
    sum: (funcName, campaigns) ->
      _.reduce(campaigns, (memo, campaign) ->
        memo += service[funcName](campaign)
      , 0)

    # total visitors
    totalVisitors: (campaign) ->
      (campaign.cumulative?.exp?.delivery_count + campaign.cumulative?.ctrl?.delivery_count) || 0

    # total conversions
    totalConversions: (campaign) ->
      (campaign.cumulative?.exp?.conversion_count + campaign.cumulative?.ctrl?.conversion_count) || 0

    # total conversion price
    totalConversionPrice: (campaign) ->
      (campaign.cumulative?.exp?.conversion_price+campaign.cumulative?.ctrl?.conversion_price) || 0

    # total delivery count
    totalDeliveryCount: (campaign) ->
      campaign.cumulative?.exp?.delivery_count || 0

    # lift rate
    liftRate: (campaign) ->
      expConversionRate = campaign.cumulative?.exp?.conversion_count / campaign.cumulative?.exp?.delivery_count || 1
      ctrlConversionRate = campaign.cumulative?.ctrl?.conversion_count / campaign.cumulative?.ctrl?.delivery_count || 0
      liftRate = (expConversionRate - ctrlConversionRate) / expConversionRate
      return liftRate

    # total conversioncount of experimental group with lift rate
    liftedConversionCount: (campaign) ->
      campaign.cumulative?.exp?.conversion_count * service.liftRate(campaign) || 0

    # total conversionprice of experimental group with lift rate
    liftedConversionPrice: (campaign) ->
      campaign.cumulative?.exp?.conversion_price * service.liftRate(campaign) || 0

    bootstrapData: (campaign_cumulative) ->
      n_boot = 500 # bootstrap sample size
      n_rank = 10 # number of rank in response to n_boot

      create_bootstrap_data = (delivery_count, conversion_rate, n_boot) ->
        boot = [0..n_boot]
        result = _.map boot, (item) ->
          return 0 if delivery_count == 0
          sum = 0
          for i in [1..delivery_count]
            if Math.random() < conversion_rate
              sum += 1
          return sum / delivery_count
        return result

      create_histogram_data = (data, n_rank) ->
        min = _.min(data)
        max = _.max(data)
        interval = (max - min) / n_rank
        return [0, 0] if interval == 0

        ranks = []
        for i in [min..max] by interval
          ranks.push [i..(i + interval)]
        _.map ranks, (rank) ->
          mean = (rank[0] + rank[rank.length-1]) / 2 * 100
          # do the rounding
          mean = Math.round(mean*100)/100

          count = _.reduce data, (memo, d) ->
            if rank.indexOf(d) != -1
              memo += 1
            return memo
          , 0

          return [mean, count]

      delivery_count = campaign_cumulative.delivery_count
      conversion_rate = (campaign_cumulative.conversion_count / campaign_cumulative.history_count) || 0

      bootstrap = create_bootstrap_data(delivery_count, conversion_rate, n_boot)
      hist = create_histogram_data(bootstrap, n_rank)
      return hist

    campaignStatsResponseTransformer: (data) ->
      try
        data = angular.fromJson data
        for stats in data.campaign_stats
          if stats.delivery_count
            stats.average_dwell = stats.dwell / stats.delivery_count
            stats.average_history_count = stats.history_count / stats.delivery_count
            stats.cart_button_click_rate = stats.cart_button_click_count / stats.delivery_count
            stats.conversion_rate = stats.conversion_count / stats.delivery_count
            if stats.conversion_count > 0
              stats.campaign_coupon_used_rate = stats.campaign_coupon_used_count / stats.conversion_count
            else
              stats.campaign_coupon_used_rate = 0
          else
            stats.average_dwell = 0
            stats.average_history_count = 0
            stats.cart_button_click_rate = 0
            stats.conversion_rate = 0
            stats.campaign_coupon_used_rate = 0
          if stats.cart_button_click_count
            stats.cart_through_rate = stats.conversion_count / stats.cart_button_click_count
          if stats.conversion_count
            stats.average_conversion_price = stats.conversion_price / stats.conversion_count
          else
            stats.average_conversion_price = 0
          stats.start_at = $filter('changeDatetimeFrom')('regionToLocal', stats.start_at, 'integer', stats.region)
          stats.end_at = $filter('changeDatetimeFrom')('regionToLocal', stats.end_at, 'integer', stats.region)
        data
      catch
        {}

    groupById: (campaign_stats) ->
      statsById = {}
      for stats in campaign_stats

        if stats.original_conversions
          sum_conversions = lib.sumOriginalConversions stats
          conversion_string = ''

          for conversion in sum_conversions
            conversion_string += "#{conversion.price_decimal} #{conversion.currency.toUpperCase()}\n"

          stats.original_conversions_string = conversion_string

        unless statsById[stats.campaign_id]
          statsById[stats.campaign_id] =
            control: {}
            experimental: {}
        if stats.is_control
          statsById[stats.campaign_id].control = stats
        else
          statsById[stats.campaign_id].experimental = stats

      for campaign_id, stats of statsById
        if stats.control.conversion_rate
          stats.conversion_up_rate = stats.experimental.conversion_rate / stats.control.conversion_rate
        else
          stats.conversion_up_rate = 0
        if stats.experimental.conversion_rate
          control_conversion_rate = stats.control.conversion_rate or 0
          stats.conversion_lift_rate = (stats.experimental.conversion_rate - control_conversion_rate) / stats.experimental.conversion_rate
        else
          stats.conversion_lift_rate = 0
        if stats.experimental.conversion_price
          stats.contribution_price = lib.truncateFraction(stats.conversion_lift_rate * stats.experimental.conversion_price)
        else
          stats.contribution_price = 0
        if stats.experimental.conversion_count
          stats.contribution_count = lib.truncateFraction(stats.conversion_lift_rate * stats.experimental.conversion_count)
        else
          stats.contribution_count = 0

        # TODO: Switching code
        # You can remove following if statement after 2/1 !
        if (new Date('2017-02-01T00:00:00+0900') <= new Date())
          # From 2017/2/1, we will no longer display negative contribution on admin!
          stats.contribution_price = _.max([0, stats.contribution_price])
          stats.contribution_count = _.max([0, stats.contribution_count])

      statsById

    forChart: (campaign_stats) ->
      for stats in campaign_stats
        stats.conversion_rate = stats.conversion_rate * 100
        stats.average_dwell = stats.average_dwell / (1000 * 60)
        stats.cart_button_click_rate = stats.cart_button_click_rate * 100
      campaign_stats

    # start_at is 1 hour or 1 day before the filtering period (depending on
    # cumulative type in stats)
    # We will use it to choose the first value before the filtering period
    calculateCumulatives: (stats, start_at) ->
      # Filter and make sure the order is correct
      stats = _.chain(stats)
        .filter((d) -> d.start_at >= start_at)
        .sortBy('startAt')
        .value()

      # Take the first stats element, which will then be subtracted from the rest
      first = stats.splice(0, 1)[0]

      _.each stats, (d) ->
        # First handle the numbers that will be used for avg/rate
        # calculations
        _.each BASE_ITEMS, (name) ->
          d[name] = d[name] - first[name]

        # exclude base items
        chartNames = _.chain(campaignGraphOptions)
                      .map('name')
                      .reject((d) -> d in BASE_ITEMS)
                      .value()

        # Then calculate the values
        _.each chartNames, (name) ->
          d[name] = 0

          switch name
            when 'average_history_count'
              d[name] = d.history_count / d.delivery_count if d.delivery_count
            when 'average_dwell'
              d[name] = d.dwell / d.delivery_count / (1000 * 60) if d.delivery_count
            when 'average_conversion_price'
              d[name] = d.conversion_price / d.conversion_count if d.conversion_count
            when 'conversion_rate'
              d[name] = d.conversion_count / d.delivery_count * 100 if d.delivery_count
            when 'cart_button_click_rate'
              d[name] = d.cart_button_click_count / d.delivery_count * 100 if d.delivery_count
            when 'cart_through_rate'
              d[name] = d.conversion_count / d.cart_button_click_count * 100 if d.cart_button_click_count


      stats

    chisqTest: (stats) ->
      @chisqP(stats) < SIGNIFICANCE_LEVEL

    chisqP: (stats) ->
      ZCStats.chisqdist 1, @chisq(stats)

    chisq: (stats) ->
      return 0 if !stats
      total_delivery_count = stats.experimental.delivery_count + stats.control.delivery_count
      return 0 if total_delivery_count is 0
      total_conversion_rate = (stats.experimental.conversion_count + stats.control.conversion_count) / total_delivery_count
      experimental_expectation = stats.experimental.delivery_count * total_conversion_rate
      return 0 if experimental_expectation is 0
      control_expectation = stats.control.delivery_count * total_conversion_rate
      return 0 if control_expectation is 0
      experimental = ((stats.experimental.conversion_count - experimental_expectation) ** 2) / experimental_expectation
      control = ((stats.control.conversion_count - control_expectation) ** 2) / control_expectation
      experimental + control

    calculateInvoiceAmount: (project, campaign, stats) ->
      return null if stats is undefined

      if campaign.fee_calculation_type is 'contribution'
        contribution_price = stats.contribution_price
        contribution_count = stats.contribution_count
      else if campaign.fee_calculation_type is 'conversion'
        contribution_price = stats.experimental.conversion_price
        contribution_count = stats.experimental.conversion_count
      else
        throw "Unknown fee calculation type: #{campaign.fee_calculation_type}! apikey: #{project.apikey}"

      switch project.product_line
        when 'zenclerk'
          contribution_price * (campaign.fee_rate || ZC_COST_RATE)
        when 'zenclerk_lp'
          return null unless campaign.cost_per_acquisition
          campaign.cost_per_acquisition * contribution_count
        when 'zenclerk_s'
          null # not supported
        else
          throw new Error("Unexpected product line! apikey: #{project.apikey}, product_line: #{project.product_line}")

    transformReport: (json) ->
      try
        data = angular.fromJson(json)
        report = data.report_stats[0]

        if report
          transformed =
            exp:
              conversion_count: report.experimental.conversion_count
              conversion_price: report.experimental.conversion_price
              delivery_count: report.experimental.delivery_count
            ctrl:
              conversion_count: report.control.conversion_count
              conversion_price: report.control.conversion_price
              delivery_count: report.control.delivery_count
            contribution_count: report.contribution_count
            contribution_price: report.contribution_price
        else
          transformed =
            exp:
              conversion_count: 0
              conversion_price: 0
              delivery_count: 0
            ctrl:
              conversion_count: 0
              conversion_price: 0
              delivery_count: 0
            contribution_count: 0
            contribution_price: 0

        transformed.exp.average_conversion_price =
          transformed.exp.conversion_price /
          transformed.exp.conversion_count || 0
        transformed.ctrl.average_conversion_price =
          transformed.ctrl.conversion_price /
          transformed.ctrl.conversion_count || 0

        transformed.exp.conversion_rate =
          transformed.exp.conversion_count /
          transformed.exp.delivery_count || 0
        transformed.ctrl.conversion_rate =
          transformed.ctrl.conversion_count /
          transformed.ctrl.delivery_count || 0

        # lift rate
        if transformed.exp.conversion_rate == 0
          transformed.lift_rate = 0
        else
          transformed.lift_rate =
            (transformed.exp.conversion_rate -
             transformed.ctrl.conversion_rate) /
             transformed.exp.conversion_rate || 0

        # up rate
        if transformed.ctrl.conversion_rate == 0
          transformed.up_rate = 0
        else
          transformed.up_rate =
            (transformed.exp.conversion_rate /
             transformed.ctrl.conversion_rate) || 0

        transformed
      catch
        {}

  service



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/campaign_stats.service.js.coffee